import React from "react";
import { Col, Container, Image, Row, Button } from "react-bootstrap";
import { BsArrowRightCircle } from "react-icons/bs";
import "./About.css";
import me4Removebg from "../../images/me4Removebg.png";
const About = () => {
  return (
    <Container className="about-container">
      <div className="page-title mx-auto">
        <h1 className="about-title">
          About <span style={{ color: "#5c4ffd" }}>Me</span>
        </h1>
      </div>
      <Row
        id="about"
        xs={1}
        sm={1}
        md={2}
        lg={2}
        className="shadow-lg rounded-3 about-block"
      >
        <Col
          xs={12}
          sm={12}
          md={5}
          lg={5}
          className="d-flex justify-content-center align-items-center "
        >
          <div className="about-image-block">
            <div className="about-image-container">
              <Image src={me4Removebg} className="about-image" fluid />
            </div>
          </div>
        </Col>
        <Col
          xs={12}
          sm={12}
          md={7}
          lg={7}
          className="d-flex justify-content-around align-items-center "
        >
          <div className="about-content-block">
            <div className="description">
              <p>
                Howdy, This is <strong>Zahidul Islam</strong>. I am a Jr Junior
                Software Engineer. I have been working on some projects of UI
                part and backend also. I have completed my Bachelor in Computer
                Science & Engineering from North South University (NSU).
              </p>
              <p>
                Learning things like developing, designing, creating projects is
                a habit to me. Every projects of my work, I'm trying to learn
                new Tech topics & developing related stuff which is helping me
                to enrich my knowledge in this area.
              </p>
              <span className="mt-5">
                <h4 className="mb-3">Here are a few Highlights : </h4>
                <p>
                  <BsArrowRightCircle /> MERN Development
                </p>
                <p>
                  <BsArrowRightCircle /> Interactive Front End as per the design
                </p>
                <p>
                  <BsArrowRightCircle /> React Js, Next Js, Redux & Redux Toolkit, TypeScript
                </p>
                <p>
                  <BsArrowRightCircle /> Mongo DB, MySQL, Firebase
                </p>
                <p>
                  <BsArrowRightCircle /> Node Js & Express
                </p>
                <p>
                  <BsArrowRightCircle /> AWS Amplify, AWS AppSync, Bootstrap, React Bootstrap, Tailwind, MUI
                  CSS, MUI
                </p>
              </span>
              <div className="d-flex justify-content-start align-items-center mt-5">
                <span>
                  <Button class="btn btn-outline-primary">
                    <a
                      href="https://drive.google.com/file/d/1guWJiric3hJ1tiLL9myDBZufmT1-fiZN/view?usp=sharing"
                      target="_blank"
                      rel="noreferrer"
                      className="about-btn"
                    >
                      See Resume
                    </a>
                  </Button>
                </span>
                <span>
                  <Button className="ms-2 bg-success">
                    <a
                      href="https://drive.google.com/uc?export=download&id=1guWJiric3hJ1tiLL9myDBZufmT1-fiZN"
                      className="about-btn"
                    >
                      Download Resume
                    </a>
                  </Button>
                </span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
